import { useState } from 'react';

const key = 'filterPinnedState';
export const usePinFilters = () => {
    const [pinned, setPinned] = useState(() => {
        const saved = sessionStorage.getItem(key);
        return saved ? saved === 'true' : false;
    });

    const handlePinChange = (newPinned: boolean) => {
        setPinned(newPinned);
        sessionStorage.setItem(key, newPinned.toString());
    };

    return [pinned, handlePinChange] as const;
};
